import crud from '@/crud/index/index'

import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  computed,
  data,
  methods,
  mounted,

  mixins: [crud],
  resourcePath: 'v1/search/professionals/summary?limit=false&pagination=false'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/identification/resources/index.js